import React from "react";
import "../DetailServices.css";

import {
    FaArrowDown,
    FaArrowRight,
    FaCode,
    FaLaptopCode,
    FaMobileAlt,
    FaRobot,
} from "react-icons/fa";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import CTASection from "../../CTASection";
import { Link } from "react-router-dom";

const Services = () => {
    return (
        <>
            <Header />
            <title>VisionVote Technologies | Services</title>
            <div className="services-page container">

                {/* ================= HERO ================= */}

                <section className="services-hero">

                    <div className="hero-overlay"></div>

                    <div className="container services-hero-content">

                        <span className="hero-badge">
                            SOFTWARE DEVELOPMENT • AI • CLOUD • CONSULTING
                        </span>

                        <h1>
                            Innovative Digital Solutions
                            <span> Designed for Modern Businesses</span>
                        </h1>

                        <p>
                            VisionVote Technologies Private Limited delivers innovative software
                            development, technology consulting, cloud solutions, artificial
                            intelligence, and digital transformation services that help
                            organizations accelerate growth, improve efficiency, and build
                            future-ready businesses.
                        </p>

                        <div className="hero-buttons">

                            <button className="primary-btn">
                                Explore Services
                                <FaArrowDown />
                            </button>

                            <a href="/contact" style={{ textDecoration: "none" }}>
                                <button className="secondary-btn">
                                    Contact Us
                                    <FaArrowRight />
                                </button>
                            </a>
                        </div>

                    </div>

                </section>

                {/* ================= INTRODUCTION ================= */}

                {/* <section className="services-intro">

                    <div className="container intro-grid">

                      

                        <div className="intro-content">

                            <span className="section-tag">
                                OUR EXPERTISE
                            </span>

                            <h2>
                                Technology That Powers
                                <span> Business Innovation</span>
                            </h2>

                            <p>
                                At VisionVote Technologies, we combine strategic consulting,
                                modern software engineering, and emerging technologies to build
                                intelligent digital solutions that solve real business
                                challenges.
                            </p>

                            <p>
                                Whether you're a startup launching your first product or an
                                enterprise modernizing existing systems, our team delivers secure,
                                scalable, and high-performance technology solutions tailored to
                                your unique business goals.
                            </p>

                            <div className="intro-points">

                                <div>
                                    <FaCode />
                                    <span>Custom Software Development</span>
                                </div>

                                <div>
                                    <FaLaptopCode />
                                    <span>Enterprise Web Applications</span>
                                </div>

                                <div>
                                    <FaMobileAlt />
                                    <span>Cross-Platform Mobile Apps</span>
                                </div>

                                <div>
                                    <FaRobot />
                                    <span>AI & Automation Solutions</span>
                                </div>

                            </div>

                        </div>

                       

                        <div className="intro-illustration">

                            <svg
                                viewBox="0 0 700 550"
                                xmlns="http://www.w3.org/2000/svg"
                            >

                                <defs>

                                    <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">

                                        <stop offset="0%" stopColor="#2563eb" />

                                        <stop offset="100%" stopColor="#60a5fa" />

                                    </linearGradient>

                                </defs>

                                <circle cx="530" cy="120" r="60" fill="#DBEAFE" />

                                <circle cx="180" cy="420" r="90" fill="#E0F2FE" />

                                <rect
                                    x="110"
                                    y="90"
                                    rx="28"
                                    ry="28"
                                    width="480"
                                    height="320"
                                    fill="url(#grad1)"
                                />

                                <rect
                                    x="145"
                                    y="130"
                                    width="410"
                                    height="230"
                                    rx="18"
                                    fill="#fff"
                                />

                                <rect
                                    x="180"
                                    y="170"
                                    width="150"
                                    height="16"
                                    rx="8"
                                    fill="#BFDBFE"
                                />

                                <rect
                                    x="180"
                                    y="210"
                                    width="260"
                                    height="14"
                                    rx="7"
                                    fill="#E5E7EB"
                                />

                                <rect
                                    x="180"
                                    y="240"
                                    width="220"
                                    height="14"
                                    rx="7"
                                    fill="#E5E7EB"
                                />

                                <rect
                                    x="180"
                                    y="285"
                                    width="90"
                                    height="90"
                                    rx="18"
                                    fill="#2563EB"
                                />

                                <rect
                                    x="295"
                                    y="285"
                                    width="90"
                                    height="90"
                                    rx="18"
                                    fill="#60A5FA"
                                />

                                <rect
                                    x="410"
                                    y="285"
                                    width="90"
                                    height="90"
                                    rx="18"
                                    fill="#BFDBFE"
                                />

                            </svg>

                        </div>

                    </div>

                </section> */}

                {/* ================= SERVICES OVERVIEW ================= */}

                <section className="services-overview">

                    <div className="container">

                        <span className="section-tag">
                            WHAT WE OFFER
                        </span>

                        <h2>
                            Comprehensive Technology
                            <span> Services</span>
                        </h2>

                        <p className="services-overview-text">
                            We provide end-to-end software development and technology consulting
                            services that enable organizations to innovate faster, optimize
                            operations, and achieve sustainable digital growth.
                        </p>

                        <div className="services-grid">

                            {/* Card 1 */}

                            <div className="service-card">

                                <div className="service-icon">💻</div>

                                <h3>Custom Software Development</h3>

                                <p>
                                    Tailored enterprise software, CRM, ERP, SaaS platforms, and business
                                    applications built specifically for your organization's needs.
                                </p>

                            </div>

                            {/* Card 2 */}

                            <div className="service-card">

                                <div className="service-icon">🌐</div>

                                <h3>Web Development</h3>

                                <p>
                                    Responsive websites, enterprise portals, eCommerce solutions, and
                                    scalable web applications using modern technologies.
                                </p>

                            </div>

                            {/* Card 3 */}

                            <div className="service-card">

                                <div className="service-icon">📱</div>

                                <h3>Mobile App Development</h3>

                                <p>
                                    Android, iOS, Flutter, and React Native applications that deliver
                                    outstanding user experiences across every device.
                                </p>

                            </div>

                            {/* Card 4 */}

                            <div className="service-card">

                                <div className="service-icon">🤖</div>

                                <h3>AI & Automation</h3>

                                <p>
                                    Intelligent automation, AI assistants, chatbots, predictive
                                    analytics, and workflow optimization solutions.
                                </p>

                            </div>

                            {/* Card 5 */}

                            <div className="service-card">

                                <div className="service-icon">☁️</div>

                                <h3>Cloud Solutions</h3>

                                <p>
                                    Cloud migration, DevOps, infrastructure modernization, CI/CD
                                    pipelines, and scalable cloud-native applications.
                                </p>

                            </div>

                            {/* Card 6 */}

                            <div className="service-card">

                                <div className="service-icon">📊</div>

                                <h3>Technology Consulting</h3>

                                <p>
                                    Strategic IT consulting, digital transformation, software
                                    architecture, and technology roadmap planning.
                                </p>

                            </div>

                            {/* Card 7 */}

                            <div className="service-card">

                                <div className="service-icon">🎨</div>

                                <h3>UI / UX Design</h3>

                                <p>
                                    User-centric interfaces, design systems, wireframes, prototypes,
                                    branding, and engaging digital experiences.
                                </p>

                            </div>

                            {/* Card 8 */}

                            <div className="service-card">

                                <div className="service-icon">🛠</div>

                                <h3>Support & Maintenance</h3>

                                <p>
                                    Continuous monitoring, software upgrades, security improvements,
                                    performance optimization, and technical support.
                                </p>

                            </div>

                        </div>

                    </div>

                </section>

                {/* ================= CUSTOM SOFTWARE DEVELOPMENT ================= */}

                <section className="service-detail">

                    <div className="container service-detail-grid">

                        {/* LEFT */}

                        <div className="service-image">

                            <svg
                                viewBox="0 0 700 500"
                                xmlns="http://www.w3.org/2000/svg"
                            >

                                <defs>

                                    <linearGradient id="softwareGradient" x1="0%" y1="0%" x2="100%" y2="100%">

                                        <stop offset="0%" stopColor="#2563eb" />

                                        <stop offset="100%" stopColor="#60a5fa" />

                                    </linearGradient>

                                </defs>

                                <rect
                                    x="90"
                                    y="70"
                                    width="520"
                                    height="340"
                                    rx="25"
                                    fill="url(#softwareGradient)"
                                />

                                <rect
                                    x="130"
                                    y="110"
                                    width="440"
                                    height="260"
                                    rx="18"
                                    fill="#ffffff"
                                />

                                <rect
                                    x="170"
                                    y="150"
                                    width="170"
                                    height="18"
                                    rx="9"
                                    fill="#2563eb"
                                />

                                <rect
                                    x="170"
                                    y="190"
                                    width="270"
                                    height="12"
                                    rx="6"
                                    fill="#CBD5E1"
                                />

                                <rect
                                    x="170"
                                    y="220"
                                    width="240"
                                    height="12"
                                    rx="6"
                                    fill="#CBD5E1"
                                />

                                <rect
                                    x="170"
                                    y="270"
                                    width="95"
                                    height="70"
                                    rx="14"
                                    fill="#2563eb"
                                />

                                <rect
                                    x="290"
                                    y="270"
                                    width="95"
                                    height="70"
                                    rx="14"
                                    fill="#60A5FA"
                                />

                                <rect
                                    x="410"
                                    y="270"
                                    width="95"
                                    height="70"
                                    rx="14"
                                    fill="#BFDBFE"
                                />

                            </svg>

                        </div>

                        {/* RIGHT */}

                        <div className="service-content">

                            <span className="service-label">
                                CUSTOM SOFTWARE DEVELOPMENT
                            </span>

                            <h2>
                                Software Built Around
                                <span> Your Business</span>
                            </h2>

                            <p>
                                Every organization operates differently, which is why off-the-shelf
                                software often falls short. At VisionVote Technologies, we develop
                                custom software solutions designed specifically for your workflows,
                                business processes, and long-term objectives.
                            </p>

                            <p>
                                From enterprise applications to SaaS platforms and internal management
                                systems, our engineering team delivers secure, scalable, and
                                future-ready software using modern technologies and agile development
                                methodologies.
                            </p>

                            <div className="feature-grid">

                                <div>✓ Enterprise Software</div>

                                <div>✓ CRM Development</div>

                                <div>✓ ERP Solutions</div>

                                <div>✓ SaaS Platforms</div>

                                <div>✓ API Development</div>

                                <div>✓ Business Automation</div>

                                <div>✓ Workflow Management</div>

                                <div>✓ System Integration</div>

                            </div>

                           <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                            <button className="detail-btn">
                                Start Your Project →
                            </button>
                            </a>

                        </div>

                    </div>

                </section>

                {/* ================= WEB DEVELOPMENT ================= */}

                <section className="service-detail alternate">

                    <div className="container service-detail-grid">

                        {/* LEFT CONTENT */}

                        <div className="service-content">

                            <span className="service-label">
                                WEB DEVELOPMENT
                            </span>

                            <h2>
                                Modern Websites &
                                <span> Enterprise Web Applications</span>
                            </h2>

                            <p>
                                Your website is more than just an online presence—it is the digital
                                face of your business. At VisionVote Technologies, we design and
                                develop responsive, secure, and high-performance web applications that
                                engage users and drive business growth.
                            </p>

                            <p>
                                Whether you need a corporate website, customer portal, SaaS platform,
                                eCommerce solution, or enterprise application, our team delivers
                                scalable solutions using modern frameworks and best development
                                practices.
                            </p>

                            <div className="feature-grid">

                                <div>✓ Corporate Websites</div>

                                <div>✓ React Development</div>

                                <div>✓ Enterprise Portals</div>

                                <div>✓ Laravel Applications</div>

                                <div>✓ eCommerce Solutions</div>

                                <div>✓ Node.js Backend</div>

                                <div>✓ API Integration</div>

                                <div>✓ SEO Optimized</div>

                            </div>

                            
                            <button className="detail-btn" onClick={() => window.location.href = '/contact'}>
                                Build Your Website →
                            </button>
                               
                        </div>

                        {/* RIGHT SVG */}

                        <div className="service-image">

                            <svg
                                viewBox="0 0 700 500"
                                xmlns="http://www.w3.org/2000/svg"
                            >

                                <defs>

                                    <linearGradient
                                        id="webGradient"
                                        x1="0%"
                                        y1="0%"
                                        x2="100%"
                                        y2="100%"
                                    >

                                        <stop offset="0%" stopColor="#2563eb" />

                                        <stop offset="100%" stopColor="#60a5fa" />

                                    </linearGradient>

                                </defs>

                                <circle
                                    cx="560"
                                    cy="90"
                                    r="50"
                                    fill="#DBEAFE"
                                />

                                <circle
                                    cx="140"
                                    cy="420"
                                    r="65"
                                    fill="#E0F2FE"
                                />

                                <rect
                                    x="80"
                                    y="70"
                                    width="540"
                                    height="340"
                                    rx="22"
                                    fill="url(#webGradient)"
                                />

                                <rect
                                    x="110"
                                    y="105"
                                    width="480"
                                    height="270"
                                    rx="18"
                                    fill="#fff"
                                />

                                <circle cx="140" cy="130" r="7" fill="#ef4444" />

                                <circle cx="165" cy="130" r="7" fill="#facc15" />

                                <circle cx="190" cy="130" r="7" fill="#22c55e" />

                                <rect
                                    x="145"
                                    y="165"
                                    width="150"
                                    height="18"
                                    rx="9"
                                    fill="#2563eb"
                                />

                                <rect
                                    x="145"
                                    y="205"
                                    width="250"
                                    height="12"
                                    rx="6"
                                    fill="#CBD5E1"
                                />

                                <rect
                                    x="145"
                                    y="235"
                                    width="220"
                                    height="12"
                                    rx="6"
                                    fill="#CBD5E1"
                                />

                                <rect
                                    x="145"
                                    y="275"
                                    width="110"
                                    height="70"
                                    rx="14"
                                    fill="#2563eb"
                                />

                                <rect
                                    x="280"
                                    y="275"
                                    width="110"
                                    height="70"
                                    rx="14"
                                    fill="#60A5FA"
                                />

                                <rect
                                    x="415"
                                    y="275"
                                    width="110"
                                    height="70"
                                    rx="14"
                                    fill="#BFDBFE"
                                />

                            </svg>

                        </div>

                    </div>

                </section>

                {/* ================= MOBILE APP DEVELOPMENT ================= */}

                <section className="service-detail mobile-service">

                    <div className="container service-detail-grid">

                        {/* LEFT IMAGE */}

                        <div className="service-image">

                            <svg
                                viewBox="0 0 700 500"
                                xmlns="http://www.w3.org/2000/svg"
                            >

                                <defs>

                                    <linearGradient
                                        id="mobileGradient"
                                        x1="0%"
                                        y1="0%"
                                        x2="100%"
                                        y2="100%"
                                    >

                                        <stop offset="0%" stopColor="#2563eb" />

                                        <stop offset="100%" stopColor="#60a5fa" />

                                    </linearGradient>

                                </defs>

                                <circle cx="580" cy="90" r="55" fill="#DBEAFE" />

                                <circle cx="130" cy="420" r="70" fill="#E0F2FE" />

                                {/* Phone */}

                                <rect
                                    x="240"
                                    y="60"
                                    width="220"
                                    height="380"
                                    rx="35"
                                    fill="url(#mobileGradient)"
                                />

                                <rect
                                    x="258"
                                    y="82"
                                    width="184"
                                    height="336"
                                    rx="25"
                                    fill="#ffffff"
                                />

                                <circle
                                    cx="350"
                                    cy="395"
                                    r="10"
                                    fill="#CBD5E1"
                                />

                                <rect
                                    x="295"
                                    y="120"
                                    width="110"
                                    height="18"
                                    rx="8"
                                    fill="#2563eb"
                                />

                                <rect
                                    x="290"
                                    y="170"
                                    width="120"
                                    height="120"
                                    rx="20"
                                    fill="#60A5FA"
                                />

                                <rect
                                    x="285"
                                    y="320"
                                    width="130"
                                    height="12"
                                    rx="6"
                                    fill="#CBD5E1"
                                />

                                <rect
                                    x="300"
                                    y="350"
                                    width="100"
                                    height="12"
                                    rx="6"
                                    fill="#CBD5E1"
                                />

                            </svg>

                        </div>

                        {/* RIGHT CONTENT */}

                        <div className="service-content">

                            <span className="service-label">
                                MOBILE APP DEVELOPMENT
                            </span>

                            <h2>
                                Powerful Mobile Apps
                                <span> That Users Love</span>
                            </h2>

                            <p>
                                In today's digital-first world, mobile applications are essential for
                                engaging customers, streamlining operations, and creating new business
                                opportunities. We build secure, intuitive, and high-performance mobile
                                applications tailored to your business objectives.
                            </p>

                            <p>
                                Whether you need a native Android app, an iOS solution, or a
                                cross-platform application, our experienced developers create scalable
                                mobile experiences with beautiful user interfaces and seamless
                                performance.
                            </p>

                            <div className="feature-grid">

                                <div>✓ Android Development</div>

                                <div>✓ iOS Applications</div>

                                <div>✓ Flutter Apps</div>

                                <div>✓ React Native</div>

                                <div>✓ Enterprise Mobility</div>

                                <div>✓ API Integration</div>

                                <div>✓ App Store Deployment</div>

                                <div>✓ Ongoing Support</div>

                            </div>

                            <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                                <button className="detail-btn">
                                    Build Mobile App →
                                </button>
                            </a>

                        </div>

                    </div>

                </section>

                {/* ================= AI & AUTOMATION ================= */}

                <section className="service-detail alternate ai-service">

                    <div className="container service-detail-grid">

                        {/* LEFT CONTENT */}

                        <div className="service-content">

                            <span className="service-label">
                                AI & AUTOMATION SOLUTIONS
                            </span>

                            <h2>
                                Intelligent AI Solutions
                                <span> for Smarter Businesses</span>
                            </h2>

                            <p>
                                Artificial Intelligence is transforming the way organizations work.
                                VisionVote Technologies helps businesses leverage AI and automation to
                                streamline operations, reduce manual effort, improve decision-making,
                                and deliver exceptional customer experiences.
                            </p>

                            <p>
                                From AI-powered chatbots and intelligent assistants to workflow
                                automation, predictive analytics, and custom AI integrations, we build
                                scalable solutions that increase productivity while preparing your
                                business for the future.
                            </p>

                            <div className="feature-grid">

                                <div>✓ AI Chatbots</div>

                                <div>✓ OpenAI Integration</div>

                                <div>✓ Workflow Automation</div>

                                <div>✓ AI Assistants</div>

                                <div>✓ Machine Learning</div>

                                <div>✓ Predictive Analytics</div>

                                <div>✓ Document Intelligence</div>

                                <div>✓ Business Process Automation</div>

                            </div>

                            <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                                <button className="detail-btn">
                                    Explore AI Solutions →
                                </button>
                            </a>

                        </div>

                        {/* RIGHT SVG */}

                        <div className="service-image">

                            <svg
                                viewBox="0 0 700 500"
                                xmlns="http://www.w3.org/2000/svg"
                            >

                                <defs>

                                    <linearGradient
                                        id="aiGradient"
                                        x1="0%"
                                        y1="0%"
                                        x2="100%"
                                        y2="100%"
                                    >

                                        <stop offset="0%" stopColor="#2563eb" />

                                        <stop offset="100%" stopColor="#60a5fa" />

                                    </linearGradient>

                                </defs>

                                {/* Background */}

                                <circle
                                    cx="560"
                                    cy="90"
                                    r="55"
                                    fill="#DBEAFE"
                                />

                                <circle
                                    cx="130"
                                    cy="420"
                                    r="70"
                                    fill="#E0F2FE"
                                />

                                {/* AI Core */}

                                <circle
                                    cx="350"
                                    cy="250"
                                    r="75"
                                    fill="url(#aiGradient)"
                                />

                                <circle
                                    cx="350"
                                    cy="250"
                                    r="45"
                                    fill="#ffffff"
                                />

                                {/* Neural Connections */}

                                <line
                                    x1="350"
                                    y1="175"
                                    x2="350"
                                    y2="90"
                                    stroke="#2563eb"
                                    strokeWidth="4"
                                />

                                <line
                                    x1="350"
                                    y1="325"
                                    x2="350"
                                    y2="410"
                                    stroke="#2563eb"
                                    strokeWidth="4"
                                />

                                <line
                                    x1="275"
                                    y1="250"
                                    x2="190"
                                    y2="250"
                                    stroke="#2563eb"
                                    strokeWidth="4"
                                />

                                <line
                                    x1="425"
                                    y1="250"
                                    x2="510"
                                    y2="250"
                                    stroke="#2563eb"
                                    strokeWidth="4"
                                />

                                <line
                                    x1="300"
                                    y1="200"
                                    x2="230"
                                    y2="130"
                                    stroke="#2563eb"
                                    strokeWidth="4"
                                />

                                <line
                                    x1="400"
                                    y1="200"
                                    x2="470"
                                    y2="130"
                                    stroke="#2563eb"
                                    strokeWidth="4"
                                />

                                <line
                                    x1="300"
                                    y1="300"
                                    x2="230"
                                    y2="370"
                                    stroke="#2563eb"
                                    strokeWidth="4"
                                />

                                <line
                                    x1="400"
                                    y1="300"
                                    x2="470"
                                    y2="370"
                                    stroke="#2563eb"
                                    strokeWidth="4"
                                />

                                {/* Nodes */}

                                <circle cx="350" cy="90" r="18" fill="#2563eb" />
                                <circle cx="350" cy="410" r="18" fill="#60A5FA" />

                                <circle cx="190" cy="250" r="18" fill="#2563eb" />
                                <circle cx="510" cy="250" r="18" fill="#60A5FA" />

                                <circle cx="230" cy="130" r="18" fill="#93C5FD" />
                                <circle cx="470" cy="130" r="18" fill="#2563eb" />

                                <circle cx="230" cy="370" r="18" fill="#60A5FA" />
                                <circle cx="470" cy="370" r="18" fill="#BFDBFE" />

                                {/* AI Symbol */}

                                <text
                                    x="350"
                                    y="265"
                                    fontSize="34"
                                    textAnchor="middle"
                                    fill="#2563eb"
                                    fontWeight="bold"
                                >
                                    AI
                                </text>

                            </svg>

                        </div>

                    </div>

                </section>

                {/* ================= CLOUD SOLUTIONS ================= */}

                <section className="service-detail cloud-service">

                    <div className="container service-detail-grid">

                        {/* LEFT IMAGE */}

                        <div className="service-image">

                            <svg
                                viewBox="0 0 700 500"
                                xmlns="http://www.w3.org/2000/svg"
                            >

                                <defs>

                                    <linearGradient
                                        id="cloudGradient"
                                        x1="0%"
                                        y1="0%"
                                        x2="100%"
                                        y2="100%"
                                    >

                                        <stop offset="0%" stopColor="#2563eb" />

                                        <stop offset="100%" stopColor="#60a5fa" />

                                    </linearGradient>

                                </defs>

                                {/* Background */}

                                <circle cx="560" cy="90" r="55" fill="#DBEAFE" />

                                <circle cx="130" cy="420" r="70" fill="#E0F2FE" />

                                {/* Cloud */}

                                <path
                                    d="M250 280
             C250 220 300 190 350 205
             C365 160 410 145 455 170
             C500 165 540 200 540 245
             C585 250 610 280 610 320
             C610 370 570 405 515 405
             L275 405
             C220 405 180 370 180 320
             C180 290 205 265 250 280Z"
                                    fill="url(#cloudGradient)"
                                />

                                {/* Server */}

                                <rect
                                    x="280"
                                    y="240"
                                    width="220"
                                    height="40"
                                    rx="10"
                                    fill="#fff"
                                />

                                <rect
                                    x="280"
                                    y="295"
                                    width="220"
                                    height="40"
                                    rx="10"
                                    fill="#fff"
                                />

                                <rect
                                    x="280"
                                    y="350"
                                    width="220"
                                    height="40"
                                    rx="10"
                                    fill="#fff"
                                />

                                <circle cx="305" cy="260" r="6" fill="#22c55e" />

                                <circle cx="305" cy="315" r="6" fill="#22c55e" />

                                <circle cx="305" cy="370" r="6" fill="#22c55e" />

                                <rect
                                    x="330"
                                    y="255"
                                    width="135"
                                    height="10"
                                    rx="5"
                                    fill="#CBD5E1"
                                />

                                <rect
                                    x="330"
                                    y="310"
                                    width="135"
                                    height="10"
                                    rx="5"
                                    fill="#CBD5E1"
                                />

                                <rect
                                    x="330"
                                    y="365"
                                    width="135"
                                    height="10"
                                    rx="5"
                                    fill="#CBD5E1"
                                />

                            </svg>

                        </div>

                        {/* RIGHT CONTENT */}

                        <div className="service-content">

                            <span className="service-label">
                                CLOUD SOLUTIONS & DEVOPS
                            </span>

                            <h2>
                                Accelerate Your Business with
                                <span> Cloud Technologies</span>
                            </h2>

                            <p>
                                Modern businesses require scalable, secure, and highly available
                                cloud infrastructure to support continuous innovation. At VisionVote
                                Technologies, we help organizations migrate, optimize, and manage
                                cloud environments that improve performance while reducing operational
                                costs.
                            </p>

                            <p>
                                Our cloud experts design resilient infrastructures, automate
                                deployments, implement DevOps best practices, and ensure your
                                applications remain reliable, secure, and future-ready across leading
                                cloud platforms.
                            </p>

                            <div className="feature-grid">

                                <div>✓ Cloud Migration</div>

                                <div>✓ AWS Solutions</div>

                                <div>✓ Microsoft Azure</div>

                                <div>✓ Google Cloud</div>

                                <div>✓ Docker & Kubernetes</div>

                                <div>✓ CI/CD Pipelines</div>

                                <div>✓ Infrastructure as Code</div>

                                <div>✓ Monitoring & Security</div>

                            </div>

                            <a href="/contact" to="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                                <button className="detail-btn">
                                    Move to Cloud →
                                </button>
                            </a>


                        </div>

                    </div>

                </section>

                {/* ================= TECHNOLOGY CONSULTING ================= */}

                <section className="service-detail alternate consulting-service">

                    <div className="container service-detail-grid">

                        {/* LEFT CONTENT */}

                        <div className="service-content">

                            <span className="service-label">
                                TECHNOLOGY CONSULTING
                            </span>

                            <h2>
                                Strategic IT Consulting for
                                <span> Business Growth</span>
                            </h2>

                            <p>
                                Technology should be a catalyst for growth, innovation, and operational
                                excellence. At VisionVote Technologies, we help organizations make
                                informed technology decisions through strategic consulting and digital
                                transformation planning.
                            </p>

                            <p>
                                Our consultants work closely with businesses to understand their goals,
                                optimize existing systems, modernize legacy applications, and implement
                                scalable technology solutions that deliver measurable business value.
                            </p>

                            <div className="feature-grid">

                                <div>✓ Technology Roadmap</div>

                                <div>✓ Digital Transformation</div>

                                <div>✓ Cloud Strategy</div>

                                <div>✓ Process Automation</div>

                                <div>✓ Architecture Consulting</div>

                                <div>✓ Software Modernization</div>

                                <div>✓ IT Infrastructure Planning</div>

                                <div>✓ Business Process Optimization</div>

                            </div>

                             <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                                <button className="detail-btn">
                                    Schedule Consultation →
                                </button>
                            </a>

                        </div>

                        {/* RIGHT SVG */}

                        <div className="service-image">

                            <svg
                                viewBox="0 0 700 500"
                                xmlns="http://www.w3.org/2000/svg"
                            >

                                <defs>

                                    <linearGradient
                                        id="consultGradient"
                                        x1="0%"
                                        y1="0%"
                                        x2="100%"
                                        y2="100%"
                                    >
                                        <stop offset="0%" stopColor="#2563eb" />
                                        <stop offset="100%" stopColor="#60a5fa" />
                                    </linearGradient>

                                </defs>

                                <circle cx="560" cy="90" r="55" fill="#DBEAFE" />
                                <circle cx="140" cy="410" r="70" fill="#E0F2FE" />

                                {/* Laptop */}

                                <rect
                                    x="170"
                                    y="90"
                                    width="360"
                                    height="220"
                                    rx="18"
                                    fill="url(#consultGradient)"
                                />

                                <rect
                                    x="190"
                                    y="110"
                                    width="320"
                                    height="180"
                                    rx="12"
                                    fill="#fff"
                                />

                                <rect
                                    x="220"
                                    y="145"
                                    width="110"
                                    height="16"
                                    rx="8"
                                    fill="#2563eb"
                                />

                                <rect
                                    x="220"
                                    y="180"
                                    width="220"
                                    height="10"
                                    rx="5"
                                    fill="#CBD5E1"
                                />

                                <rect
                                    x="220"
                                    y="205"
                                    width="190"
                                    height="10"
                                    rx="5"
                                    fill="#CBD5E1"
                                />

                                {/* Chart */}

                                <rect
                                    x="230"
                                    y="235"
                                    width="22"
                                    height="30"
                                    fill="#60A5FA"
                                />

                                <rect
                                    x="270"
                                    y="220"
                                    width="22"
                                    height="45"
                                    fill="#2563eb"
                                />

                                <rect
                                    x="310"
                                    y="195"
                                    width="22"
                                    height="70"
                                    fill="#3B82F6"
                                />

                                <rect
                                    x="350"
                                    y="175"
                                    width="22"
                                    height="90"
                                    fill="#2563eb"
                                />

                                {/* Laptop Base */}

                                <rect
                                    x="140"
                                    y="315"
                                    width="420"
                                    height="25"
                                    rx="10"
                                    fill="#94A3B8"
                                />

                            </svg>

                        </div>

                    </div>

                </section>

                {/* ================= UI/UX DESIGN ================= */}

                <section className="service-detail uiux-service alternate">

                    <div className="container service-detail-grid">

                        {/* LEFT CONTENT */}

                        <div className="service-image">

                            <svg
                                viewBox="0 0 700 500"
                                xmlns="http://www.w3.org/2000/svg"
                            >

                                <defs>
                                    <linearGradient
                                        id="uiuxGradient"
                                        x1="0%"
                                        y1="0%"
                                        x2="100%"
                                        y2="100%"
                                    >
                                        <stop offset="0%" stopColor="#7c3aed" />
                                        <stop offset="100%" stopColor="#a78bfa" />
                                    </linearGradient>
                                </defs>

                                {/* background shapes */}
                                <circle cx="120" cy="100" r="60" fill="#ede9fe" />
                                <circle cx="580" cy="420" r="80" fill="#f5f3ff" />

                                {/* mobile frame */}
                                <rect
                                    x="250"
                                    y="70"
                                    width="200"
                                    height="360"
                                    rx="28"
                                    fill="url(#uiuxGradient)"
                                />

                                <rect
                                    x="265"
                                    y="95"
                                    width="170"
                                    height="310"
                                    rx="20"
                                    fill="#ffffff"
                                />

                                {/* header UI */}
                                <rect x="285" y="120" width="130" height="14" rx="7" fill="#7c3aed" />
                                <rect x="285" y="145" width="100" height="10" rx="5" fill="#c4b5fd" />

                                {/* cards */}
                                <rect x="285" y="175" width="130" height="50" rx="10" fill="#ede9fe" />
                                <rect x="285" y="235" width="130" height="50" rx="10" fill="#ede9fe" />

                                {/* buttons */}
                                <rect x="285" y="305" width="60" height="20" rx="10" fill="#7c3aed" />
                                <rect x="355" y="305" width="60" height="20" rx="10" fill="#a78bfa" />

                                {/* bottom nav */}
                                <rect x="275" y="360" width="150" height="25" rx="12" fill="#ddd6fe" />

                            </svg>

                        </div>



                        {/* RIGHT SVG */}

                        <div className="service-content">

                            <span className="service-label">
                                UI/UX DESIGN
                            </span>

                            <h2>
                                User-Centric UI/UX Design for
                                <span> Engaging Digital Experiences</span>
                            </h2>

                            <p>
                                Great products start with great design. At VisionVote Technologies,
                                we craft intuitive, accessible, and visually compelling user interfaces
                                that enhance user satisfaction and drive engagement.
                            </p>

                            <p>
                                From research and wireframing to prototyping and final UI systems,
                                we design seamless digital experiences that align user needs with
                                business goals.
                            </p>

                            <div className="feature-grid">

                                <div>✓ User Research</div>
                                <div>✓ Wireframing</div>
                                <div>✓ Interactive Prototypes</div>
                                <div>✓ Design Systems</div>
                                <div>✓ UI Design</div>
                                <div>✓ UX Strategy</div>
                                <div>✓ Branding & Identity</div>
                                <div>✓ Usability Testing</div>

                            </div>

                          <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                            <button className="detail-btn">
                                Start Your Design →
                            </button>
                            </a>

                        </div>
                    </div>

                </section>
                {/* ================= SUPPORT & MAINTENANCE ================= */}

                <section className="service-detail support-service">

                    <div className="container service-detail-grid">

                        {/* LEFT CONTENT */}
                        <div className="service-content">

                            <span className="service-label">
                                SUPPORT & MAINTENANCE
                            </span>

                            <h2>
                                Reliable Support & Maintenance for
                                <span> Continuous Performance</span>
                            </h2>

                            <p>
                                We ensure your systems run smoothly with proactive monitoring,
                                regular updates, and fast issue resolution. Our goal is to keep
                                your applications secure, stable, and always performing at their best.
                            </p>

                            <p>
                                From bug fixes and security patches to performance tuning and
                                infrastructure support, we provide end-to-end maintenance that
                                minimizes downtime and maximizes efficiency.
                            </p>

                            <div className="feature-grid">

                                <div>✓ 24/7 Monitoring</div>
                                <div>✓ Bug Fixing & Updates</div>
                                <div>✓ Security Enhancements</div>
                                <div>✓ Performance Optimization</div>
                                <div>✓ Version Upgrades</div>
                                <div>✓ Backup Management</div>
                                <div>✓ Technical Support</div>
                                <div>✓ System Health Checks</div>

                            </div>

                            <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                                <button className="detail-btn">
                                    Get Support →
                                </button>
                            </a>
                        </div>

                        {/* RIGHT SVG */}
                        <div className="service-image">

                            <svg viewBox="0 0 700 500" xmlns="http://www.w3.org/2000/svg">

                                <defs>
                                    <linearGradient
                                        id="supportGradient"
                                        x1="0%"
                                        y1="0%"
                                        x2="100%"
                                        y2="100%"
                                    >
                                        <stop offset="0%" stopColor="#10b981" />
                                        <stop offset="100%" stopColor="#34d399" />
                                    </linearGradient>
                                </defs>

                                {/* background shapes */}
                                <circle cx="120" cy="120" r="60" fill="#d1fae5" />
                                <circle cx="580" cy="400" r="80" fill="#ecfdf5" />

                                {/* server box */}
                                <rect
                                    x="230"
                                    y="90"
                                    width="240"
                                    height="300"
                                    rx="20"
                                    fill="url(#supportGradient)"
                                />

                                <rect
                                    x="255"
                                    y="120"
                                    width="190"
                                    height="240"
                                    rx="15"
                                    fill="#ffffff"
                                />

                                {/* server lines */}
                                <rect x="270" y="150" width="160" height="12" rx="6" fill="#6ee7b7" />
                                <rect x="270" y="175" width="120" height="10" rx="5" fill="#a7f3d0" />
                                <rect x="270" y="200" width="140" height="10" rx="5" fill="#a7f3d0" />

                                {/* status indicators */}
                                <circle cx="275" cy="245" r="6" fill="#10b981" />
                                <circle cx="295" cy="245" r="6" fill="#34d399" />
                                <circle cx="315" cy="245" r="6" fill="#6ee7b7" />

                                {/* shield icon style */}
                                <path
                                    d="M350 280 L390 300 L350 350 L310 300 Z"
                                    fill="#10b981"
                                    opacity="0.3"
                                />

                                {/* bottom base */}
                                <rect
                                    x="210"
                                    y="390"
                                    width="280"
                                    height="25"
                                    rx="12"
                                    fill="#a7f3d0"
                                />

                            </svg>

                        </div>

                    </div>

                </section>
            </div>
            <CTASection />
            <Footer />
        </>

    );
};

export default Services;